import {CourseModel} from '@/models/content/course';
import { taxonomySerializer } from './taxonomy';
import { sessionService } from '@/providers/services/auth/session';
import { DEFAULT_IMAGES_PATH } from '@/utils/constants';
import { gutCourseNames, truncateString } from '@/utils/utils';
import moment from 'moment';

export class CourseSerializer {
  private static INSTANCE = new CourseSerializer();

  static get instance() {
    return this.INSTANCE;
  }

  public serializeCourse(course: any): CourseModel {
    const cdnUrls = sessionService.getCdnUrl();
    const contentCdnUrl = cdnUrls.content_cdn_url;
    const thumbnailUrl = course.thumbnail ?
      contentCdnUrl + course.thumbnail :
        `${window.location.origin}/` + DEFAULT_IMAGES_PATH.unit;
    const result: CourseModel = {
      id: course.id,
      title: course.title,
      description: course.description,
      format: course.format || 'course',
      efficacy: course.efficacy,
      relevance: course.relevance,
      engagement: course.engagement,
      standards: taxonomySerializer.normalizeTaxonomyObject(course.taxonomy),
      creator: taxonomySerializer.normalizeCreator(course.creator),
      unitCount: course.unitCount,
      thumbnailUrl,
    };
    return result;
  }

  public normalizeCourseContent(courseData: any) {
    const serializer = this;
    const serializedCourseData = courseData;
    const taxonomy = taxonomySerializer.normalizeTaxonomyObject(courseData.taxonomy);
    serializedCourseData.taxonomy = taxonomy;
    const aggregatedTaxonomy = taxonomySerializer.normalizeTaxonomyArray(courseData.aggregated_taxonomy, false);
    serializedCourseData.aggregated_taxonomy = aggregatedTaxonomy;
    return serializedCourseData;
  }


  public coursePulloutSerializer(course: any, coursePullOutData: any) {
    const defaultVectorValue = 0.5;
    let resultSet = {};
    if (course) {
      resultSet = {
        descriptive: {
          title: course.title,
          description: truncateString(course.description),
        },

        creation: {
          'Created On':
            moment(course.createdDate).format('MMMM DD, YYYY') || null,
          'Publisher': 'Gooru Org',
          'Publish Status': course.isPublished ? 'Published' : 'Unpublished',
          'Aggregator': course.aggregator ? course.aggregator : null,
          'Modified On':
            moment(course.lastModified).format('MMMM DD, YYYY') || null,
          'Modified By':
            course.lastModifiedUser.username || course.lastModifiedBy,
          'License': coursePullOutData.license
            ? coursePullOutData.license
            : 'Public Domain',
          'Host': null,
        },

        educational: {
          Audience: course.audience,
        },

        media: {
          Keywords: null,
          Visibility: coursePullOutData.visible_on_profile ? 'True' : 'False',
        },

        instructional: {
          '21st Century Skills': null,
        },

        framework: {
          subject: course.taxonomySubject,
          Course: gutCourseNames(course.taxonomyCourse),
          domain: course.taxonomyDomain,
          Standards: course.standards || [],
        },

        vector: {
          relevance: course.relevance || defaultVectorValue,
          engagement: course.engagement || defaultVectorValue,
          efficacy: course.efficacy || defaultVectorValue,
        },
      };
    }
    return resultSet;
  }

}

export const courseSerializer = CourseSerializer.instance;
